import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface SidebarContextType {
  isSidebarVisible: boolean;
  setIsSidebarVisible: (visible: boolean) => void;
  toggleSidebar: () => void;
  isTemplatesPanelOpen: boolean;
  openTemplatesPanel: () => void;
  closeTemplatesPanel: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [isTemplatesPanelOpen, setIsTemplatesPanelOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarVisible(prev => !prev);
  };

  const openTemplatesPanel = () => setIsTemplatesPanelOpen(true);
  const closeTemplatesPanel = () => setIsTemplatesPanelOpen(false);

  const value = useMemo(
    () => ({
      isSidebarVisible,
      setIsSidebarVisible,
      toggleSidebar,
      isTemplatesPanelOpen,
      openTemplatesPanel,
      closeTemplatesPanel,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isSidebarVisible, isTemplatesPanelOpen]
  );

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
